import {
  Expense,
  ExpenseMode,
  ExpenseStatus,
} from '../../../../interfaces/delivery-company/expenses';
import {
  RecurrentExpense,
  RecurrentExpenseFrequency,
  RecurrentExpenseNature,
} from '../../../../interfaces/delivery-company/recurrent-expenses';

export const emptyRecurringExpense: RecurrentExpense = {
  id: 0,
  name: '',
  nature: RecurrentExpenseNature.EXPENSE,
  expense: [],
  description: '',
  frequency: RecurrentExpenseFrequency.MONTHLY,
  is_active: true,
};
